import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  QppPensionOptionsInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/qpp-pension/qpp-pension-options-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-qpp-pension-form',
  templateUrl: './salary-dividend-qpp-pension-form.component.html',
  styleUrls: ['./salary-dividend-qpp-pension-form.component.scss'],
  standalone: false,
})
export class SalaryDividendQppPensionFormComponent {

  @Input()
  qppPensionForm: AdvancedFormGroup<QppPensionOptionsInSalaryDividendOptions>;

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  isMarriedSubscription;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  refresh() {
  }
}
